import { Dialog, Button, AppBar, Toolbar, IconButton, Typography, DialogContent, DialogActions} from "@mui/material"
import { FunctionField, RaRecord, SimpleShowLayout, TextField, useGetIdentity, useNotify, useTranslate } from "react-admin"
import { Close } from '@mui/icons-material';
import { Dispatch, SetStateAction } from "react";
import { apiService } from "../apiService";
import { NumberRangeReadModel, SetNumberRangeToDefaultCommand } from "../GeneratedClients/FreeBillApi";
import { useMutation } from "react-query";
import CustomCommandProgress from "../customStyles/CustomCommandProgress";

interface IProps {
  record?: RaRecord
  setRecord: Dispatch<SetStateAction<RaRecord | undefined>>
}

const SetToDefaultDialog = ({record, setRecord}:IProps) => {
  const { data: identity, isLoading: identityLoading } = useGetIdentity()
  const translate = useTranslate()
  const open = record !== undefined
  const notify = useNotify()
  const { mutate: setNumberRangeToDefault, isLoading } = useMutation((command: SetNumberRangeToDefaultCommand) => 
    apiService.NumberRangesApi.setNumberRangeToDefault({setNumberRangeToDefaultCommand: command, id: command.id!})
  )

  const handleClose = () => {
    setRecord(undefined)
  }

  const setToDefault = async() => {
    record?.id && identity?.id && setNumberRangeToDefault({
      userId: identity.id.toString(), id: record.id.toString()
    }, {
      onSuccess() {
        notify(translate("resources.numberRanges.notifications.markedAsDefault", {title: record?.name}))
        handleClose()
      },
      onError(error: any) {
        notify(error, {type: 'error'})
      }
    })
  }

  if(identityLoading) return null

  return (
    <>
      <Dialog 
        open={open}
        onClose={handleClose}
      >
        <AppBar sx={{position: 'relative'}}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
            >
              <Close />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} component={'div'} variant="h6" color={"inherit"}>
              {translate('resources.numberRanges.dialogs.markAsDefault')}
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent >
          <SimpleShowLayout record={record}>
            <TextField source="name" record={record} label="resources.numberRanges.title" />
            <FunctionField render={(numberRange: NumberRangeReadModel) => `${numberRange.value}${numberRange.nextNumber}`} label="resources.numberRanges.nextNumber" sortable={false} />
          </SimpleShowLayout>
          { isLoading && <CustomCommandProgress timeInMs={40} /> }
        </DialogContent>
        <DialogActions>
          <Button disabled={isLoading} onClick={setToDefault} >{translate('resources.numberRanges.actions.select')}</Button>
        </DialogActions>
      </Dialog>
    </>

  )
}

export default SetToDefaultDialog